import base from '../orgs/orgs.js'
import { cloneDeep } from 'lodash'
import studioMetricRenderer from './components/studioMetricRenderer.vue'
import getRecords from 'src/utils/entityOperations/getRecords'

const derived = cloneDeep(base)

derived.getters.columns = (state, getters, rootState, rootGetters) => {
  let cols = base.getters.columns(state, getters, rootState)
  cols = cols.filter(col => !['del', 'org_level_id', 'parent_id'].includes(col.name))
  cols.find(r => r.name === 'name').inlineEdit = false

  const commonMetricProps = metricObject => ({ isNumeric: true, isInteger: true, hideWhenCreating: true, component: studioMetricRenderer, componentProps: (col, row) => ({ row, col, studio_metric_ids_prop: [metricObject.id] }) })

  const studioMetrics = getRecords('ci.studio_metrics')

  cols.push(...studioMetrics.sort((a, b) => a.display_order - b.display_order).map(m => ({
    ...commonMetricProps(m),
    name: m.ci_studios_field,
    field: m.ci_studios_field,
    label: m.name,
    metricObject: m,
    hideWhenDisplaying: m.hide_when_displaying_by_default,
    headerInfoTip: m.name.includes('Total attendance') ? '"Total attendance" = Checked-in + penalty cancel + penalty no-show' : null,
    ...m.ui_column_mixin_defs
  })))

  cols.push({
    name: 'automatic_inventory_and_pricing_management_disabled',
    editable: true,
    label: 'Disable inventory management and pricing automation',
    headerInfoTip: 'If this toggle is on, the system will not send inventory and pricing data.',
    field: 'automatic_inventory_and_pricing_management_disabled',
    source_table: 'ci.studios_extends_orgs',
    isToggle: true
  })

  cols.push({
    name: 'automatic_class_standby_capacity_management_is_disabled',
    editable: true,
    label: 'Disable class standby management automation',
    headerInfoTip: 'If this toggle is on, the system will not manage standy capacity for this studio.',
    field: 'automatic_class_standby_capacity_management_is_disabled',
    source_table: 'ci.studios_extends_orgs',
    isToggle: true
  })

  cols.push({
    name: 'instructor_scheduling_app_automation_is_disabled',
    editable: true,
    label: 'Disable instructor scheduling automation',
    headerInfoTip: 'If this toggle is on, instructor management app is not going to be turned on for this location.',
    field: 'instructor_scheduling_app_automation_is_disabled',
    source_table: 'ci.studios_extends_orgs',
    isToggle: true
  })

  cols.push({
    name: 'timesheet_management_app_is_disabled',
    editable: true,
    label: 'Disable TVT app',
    headerInfoTip: 'If this toggle is on, TVT app is not going to be turned on for this location.',
    field: 'timesheet_management_app_is_disabled',
    source_table: 'ci.studios_extends_orgs',
    isToggle: true
  })

  cols.push({
    name: 'is_at_home_studio',
    editable: true,
    label: 'Is at-home studio',
    field: 'is_at_home_studio',
    source_table: 'ci.studios_extends_orgs',
    isToggle: true
  })

  return cols
}

export default derived
